import {
  BookOpen,
  Clock,
  AlertTriangle,
  Camera,
  Cigarette,
  Car,
  FileText,
  DollarSign,
  Users,
  Shield,
  Wrench,
  MapPin,
  Star,
  Phone,
  Settings,
  HelpCircle,
  LucideIcon,
} from "lucide-react";

export const iconMap: Record<string, LucideIcon> = {
  BookOpen,
  Clock,
  AlertTriangle,
  Camera,
  Cigarette,
  Car,
  FileText,
  DollarSign,
  Users,
  Shield,
  Wrench,
  MapPin,
  Star,
  Phone,
  Settings,
  HelpCircle,
};

export const getIcon = (iconName: string): LucideIcon => {
  return iconMap[iconName] || BookOpen;
};

export const iconOptions = Object.keys(iconMap);
